import app from 'flarum/forum/app';
import { extend } from 'flarum/extend';
import UserCard from 'flarum/forum/components/UserCard';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import Switch from 'flarum/common/components/Switch';
import icon from 'flarum/common/helpers/icon';

// 添加调试日志
console.log('PT人生扩展初始化中...');

// 安全的JSON解析函数
function safeJSONParse(jsonString) {
  if (!jsonString) return null;
  
  // 如果已经是对象，则直接返回
  if (typeof jsonString === 'object') return jsonString;
  
  try {
    // 替换所有Infinity为字符串"Infinity"，然后解析
    const safeString = jsonString.replace(/"ratio"\s*:\s*Infinity/g, '"ratio":"Infinity"');
    return JSON.parse(safeString);
  } catch (e) {
    console.error('JSON解析错误:', e, jsonString);
    return null;
  }
}

// 智能单位转换函数
function formatSize(bytes) {
  if (typeof bytes !== 'number' || isNaN(bytes) || bytes < 0) return '0 B';
  
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let size = bytes;
  let unitIndex = 0;
  
  // 转换到合适的单位
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }
  
  // 保留两位小数
  return size.toFixed(2) + ' ' + units[unitIndex];
}

app.initializers.add('pting-mp-stats', () => {
  console.log('PT人生扩展样式添加中...');
  
  // 添加自定义样式
  $('head').append(`
    <style>
      .MPStats {
        margin-top: 15px;
        border-radius: 8px;
        padding: 10px;
        position: relative;
        overflow: visible;
        max-width: 100%;
      }
      
      /* 毛玻璃效果背景 */
      .MPStats::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        z-index: -1;
        border-radius: 8px;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
      }
      
      /* 深色模式下的毛玻璃效果 */
      .nightmode .MPStats::before {
        background: rgba(30, 30, 30, 0.5);
      }
      
      .MPStats-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        border-bottom: 1px solid rgba(50, 50, 50, 0.1);
        padding-bottom: 6px;
      }
      
      .MPStats-headerLeft {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      
      .MPStats-title {
        font-weight: bold;
        font-size: 15px;
        display: flex;
        align-items: center;
        color: var(--heading-color);
        text-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);
      }
      
      .MPStats-updated {
        font-size: 11px;
        color: var(--muted-color);
      }
      
      .MPStats-summary {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 8px;
        gap: 6px;
      }
      
      .MPStats-card {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 6px;
        padding: 6px 4px;
        flex: 1 0 calc(20% - 8px);
        min-width: 85px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        text-align: center;
        transition: transform 0.2s, box-shadow 0.2s;
      }
      
      /* 深色模式下的卡片 */
      .nightmode .MPStats-card {
        background: rgba(60, 60, 60, 0.3);
      }
      
      .MPStats-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
      }
      
      .MPStats-cardIcon {
        font-size: 14px;
        margin-bottom: 2px;
      }
      
      .MPStats-cardLabel {
        font-size: 10px;
        color: var(--muted-color);
        margin-bottom: 2px;
      }
      
      .MPStats-cardValue {
        font-weight: bold;
        font-size: 13px;
      }
      
      .MPStats-upload {
        color: #4CAF50;
      }
      
      .MPStats-download {
        color: #F44336;
      }
      
      .MPStats-ratio {
        color: #9C27B0;
      }
      
      .MPStats-seed {
        color: #2196F3;
      }
      
      .MPStats-seedSize {
        color: #FF9800;
      }
      
      .MPStats-controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
      }
      
      .MPStats-visibility {
        display: flex;
        align-items: center;
      }
      
      .MPStats-visibilityLabel {
        margin-right: 8px;
        font-size: 12px;
        color: var(--muted-color);
      }
      
      /* 新增样式 - 隐私开关 */
      .MPStats-privacyToggle {
        display: flex;
        align-items: center;
        margin: 0;
      }
      
      .MPStats-privacyLabel {
        margin-right: 8px;
        font-size: 12px;
        color: var(--muted-color);
      }
      
      /* 隐私开关文字标签 */
      .MPStats-switchLabel {
        margin-left: 4px;
        font-size: 13px;
        font-weight: bold;
        color: var(--heading-color);
        cursor: pointer;
        user-select: none;
      }
      
      /* 深色模式下的标签 */
      .nightmode .MPStats-switchLabel {
        color: #fff;
      }
      
      /* 新增样式 - 十二大收集进度 */
      .MPStats-collectionProgress {
        margin: 8px 0;
        padding: 6px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 6px;
      }
      
      .MPStats-progressHeader {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
        align-items: center;
      }
      
      .MPStats-progressTitle {
        font-size: 13px;
        font-weight: bold;
        color: var(--heading-color);
      }
      
      .MPStats-progressValue {
        font-size: 12px;
        color: var(--muted-color);
      }
      
      .MPStats-progressBar {
        width: 100%;
        height: 8px;
        background: rgba(200, 200, 200, 0.2);
        border-radius: 4px;
        overflow: hidden;
      }
      
      /* 新增样式 - 精简版额外统计信息 */
      .MPStats-extraStats {
        margin: 8px 0;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        padding: 6px;
      }
      
      .MPStats-statsCompact {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
      }
      
      .MPStats-statTag {
        display: inline-flex;
        align-items: center;
        padding: 3px 8px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 500;
        white-space: nowrap;
        color: white;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      }
      
      .MPStats-statTagIcon {
        margin-right: 3px;
        font-size: 10px;
      }
      
      .MPStats-sitesCount {
        background: linear-gradient(135deg, #3949AB, #5C6BC0);
      }
      
      .MPStats-avgSeed {
        background: linear-gradient(135deg, #00897B, #26A69A);
      }
      
      .MPStats-avgSize {
        background: linear-gradient(135deg, #7B1FA2, #9C27B0);
      }
      
      .MPStats-maxSeed {
        background: linear-gradient(135deg, #F57C00, #FF9800);
      }
      
      .MPStats-maxSize {
        background: linear-gradient(135deg, #C2185B, #E91E63);
      }
      
      /* 深色模式调整 */
      .nightmode .MPStats-statTag {
        box-shadow: 0 1px 3px rgba(0,0,0,0.3);
      }
      
      /* 替换下拉菜单为展开式详情组件 */
      .MPStats-sitesDetails {
        width: 100%;
        margin-top: 10px;
        position: relative;
      }
      
      /* 站点列表标题按钮 */
      .MPStats-sitesToggle {
        width: 100%;
        text-align: center;
        padding: 4px;
        background: rgba(50, 100, 150, 0.1);
        border: none;
        border-radius: 6px;
        color: var(--heading-color);
        font-size: 12px;
        cursor: pointer;
        transition: background 0.2s;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .MPStats-sitesToggle:hover {
        background: rgba(50, 100, 150, 0.2);
      }
      
      .MPStats-sitesToggle i {
        margin-right: 5px;
      }
      
      /* 站点列表容器 */
      .MPStats-sitesList {
        margin-top: 8px;
        border-radius: 6px;
        overflow: hidden;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease-out;
      }
      
      .MPStats-sitesList.is-expanded {
        max-height: 500px;
        overflow-y: auto;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
      }
      
      /* 自定义滚动条样式 */
      .MPStats-sitesList::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      
      .MPStats-sitesList::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.05);
        border-radius: 3px;
      }
      
      .MPStats-sitesList::-webkit-scrollbar-thumb {
        background: rgba(50, 100, 150, 0.3);
        border-radius: 3px;
      }
      
      .MPStats-sitesList::-webkit-scrollbar-thumb:hover {
        background: rgba(50, 100, 150, 0.5);
      }
      
      .nightmode .MPStats-sitesList::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
      }
      
      .nightmode .MPStats-sitesList::-webkit-scrollbar-thumb {
        background: rgba(100, 150, 200, 0.3);
      }
      
      .nightmode .MPStats-sitesList {
        background: rgba(30, 30, 30, 0.5);
      }
      
      .MPStats-siteItem {
        padding: 8px 10px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        transition: background-color 0.2s;
      }
      
      .nightmode .MPStats-siteItem {
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
      }
      
      .MPStats-siteItem:hover {
        background-color: rgba(50, 100, 150, 0.05);
      }
      
      .MPStats-siteItem:last-child {
        border-bottom: none;
      }
      
      .MPStats-siteHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
      }
      
      .MPStats-siteName {
        font-weight: bold;
        font-size: 13px;
        color: var(--heading-color);
      }
      
      .MPStats-siteUser {
        font-size: 11px;
        color: var(--muted-color);
        font-style: italic;
      }
      
      .MPStats-siteStats {
        display: flex;
        flex-wrap: wrap;
        font-size: 11px;
        gap: 5px;
      }
      
      .MPStats-statItem {
        display: flex;
        align-items: center;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 12px;
        padding: 2px 6px;
        white-space: nowrap;
      }
      
      .nightmode .MPStats-statItem {
        background: rgba(60, 60, 60, 0.25);
      }
      
      .MPStats-siteUpload {
        color: #4CAF50;
      }
      
      .MPStats-siteDownload {
        color: #F44336;
      }
      
      .MPStats-siteRatio {
        color: #9C27B0;
      }
      
      .MPStats-siteBonus {
        color: #FF9800;
      }
      
      .MPStats-siteSeedingSize {
        color: #2196F3;
      }
      
      .MPStats--error {
        background: rgba(244, 67, 54, 0.08);
      }
      
      .MPStats-errorIcon {
        color: #F44336;
      }
      
      .MPStats-noSites {
        color: var(--muted-color);
        font-style: italic;
        font-size: 11px;
        text-align: center;
        padding: 10px;
      }
      
      /* 深色模式下的文字对比度提升 */
      .nightmode .MPStats {
        color: rgba(255, 255, 255, 0.85);
      }
      
      .nightmode .MPStats-cardLabel,
      .nightmode .MPStats-updated,
      .nightmode .MPStats-visibilityLabel {
        color: rgba(255, 255, 255, 0.65);
      }
      
      /* 响应式调整 */
      @media (max-width: 768px) {
        .MPStats-card {
          flex: 1 0 calc(33.33% - 6px);
        }
        
        .MPStats-cardIcon {
          font-size: 12px;
          margin-bottom: 1px;
        }
        
        .MPStats-cardValue {
          font-size: 12px;
        }
      }
      
      @media (max-width: 480px) {
        .MPStats {
          padding: 6px;
          margin-top: 8px;
        }
        
        .MPStats-header {
          margin-bottom: 4px;
          padding-bottom: 4px;
        }
        
        .MPStats-headerLeft {
          gap: 5px;
          flex-shrink: 0;
        }
        
        .MPStats-title {
          font-size: 12px;
          white-space: nowrap;
          flex-shrink: 0;
        }
        
        .MPStats-updated {
          font-size: 9px;
          max-width: 90px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        .MPStats-card {
          flex: 1 0 calc(33.33% - 3px);
          padding: 3px 2px;
          min-width: auto;
        }
        
        .MPStats-cardLabel {
          font-size: 8px;
          margin-bottom: 0;
        }
        
        .MPStats-cardValue {
          font-size: 10px;
        }
        
        .MPStats-summary {
          gap: 3px;
          margin-bottom: 4px;
        }
        
        .MPStats-collectionProgress {
          margin: 4px 0;
          padding: 3px;
        }
        
        .MPStats-progressTitle {
          font-size: 11px;
        }
        
        .MPStats-progressValue {
          font-size: 9px;
        }
        
        .MPStats-extraStats {
          margin: 4px 0;
          padding: 3px;
        }
        
        .MPStats-statsCompact {
          gap: 3px;
        }
        
        .MPStats-statTag {
          font-size: 9px;
          padding: 1px 4px;
        }
        
        .MPStats-controls {
          flex-direction: column;
          gap: 4px;
          align-items: flex-start;
        }
      }
      
      /* 完成收集特殊样式 */
      .MPStats-complete {
        display: inline-flex;
        align-items: center;
        color: #F44336;
        font-weight: bold;
        animation: pulse 1.5s infinite;
      }
      
      .MPStats-completeIcon {
        color: gold;
        margin-right: 4px;
        filter: drop-shadow(0 0 2px rgba(255, 215, 0, 0.6));
      }
      
      @keyframes pulse {
        0% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.05);
        }
        100% {
          transform: scale(1);
        }
      }
      
      /* 隐私提示样式 */
      .MPStats-privateMessage {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        color: var(--muted-color);
        font-style: italic;
        background: rgba(200, 200, 200, 0.05);
        border-radius: 6px;
        margin: 10px 0;
      }
      
      .MPStats-privateIcon {
        color: #757575;
        margin-right: 8px;
        font-size: 16px;
      }
      
      .MPStats-privateText {
        font-size: 14px;
      }
      
      .nightmode .MPStats-privateIcon {
        color: #9E9E9E;
      }
    </style>
  `);
  
  // 使用更安全的方式扩展UserCard
  extend(UserCard.prototype, 'infoItems', function(items) {
    console.log('尝试加载PT人生卡片...');
    
    const user = this.attrs.user;
    if (!user) {
      console.log('用户对象不存在，无法显示PT人生卡片');
      return;
    }
    
    // 检查是否是当前用户
    const isCurrentUser = app.session.user && app.session.user.id() === user.id();
    console.log('当前用户状态:', isCurrentUser ? '是当前用户' : '不是当前用户');
    
    try {
      // 从用户属性中获取数据
      let summaryRaw = user.attribute('mpStatsSummary');
      let sitesRaw = user.attribute('mpStatsSites');
      
      // 如果找不到驼峰命名的属性，尝试下划线命名
      if (!summaryRaw) {
        summaryRaw = user.attribute('mp_stats_summary');
      }
      
      if (!sitesRaw) {
        sitesRaw = user.attribute('mp_stats_sites');
      }
      
      // 获取隐私设置
      const mpStatsPublic = user.attribute('mp_stats_public');
      const isPublic = typeof mpStatsPublic !== 'undefined' ? mpStatsPublic : 1;
      
      // 确保数据存在
      if (!summaryRaw || !sitesRaw) {
        return;
      }
      
      // 使用安全解析函数
      const summary = safeJSONParse(summaryRaw);
      const sites = safeJSONParse(sitesRaw);
      
      if (!summary || !sites || !Array.isArray(sites)) {
        return;
      }
      
      // 创建站点项组件数组
      const siteItems = sites.map(site => {
        // 处理站点比率，确保Infinity值被正确显示
        let siteRatio = site.ratio;
        if (siteRatio === "Infinity" || siteRatio === Infinity) {
          siteRatio = '∞';
        } else if (typeof siteRatio === 'number') {
          siteRatio = siteRatio.toFixed(2);
        }
        
        // 格式化站点上传下载数据
        const siteUpload = formatSize(site.upload);
        const siteDownload = formatSize(site.download);
        const seedingSize = formatSize(site.seeding_size || 0);
        
        return m('div.MPStats-siteItem', {
          key: site.name,
          onclick: (e) => { e.redraw = false; } // 防止冒泡和重绘
        }, [
          // 站点名称和用户信息行
          m('div.MPStats-siteHeader', [
            m('div.MPStats-siteName', site.name),
            site.username ? m('div.MPStats-siteUser', [
              site.username,
              site.user_level ? m('span.MPStats-siteUserLevel', ` (${site.user_level})`) : null
            ]) : null
          ]),
          // 站点统计数据行
          m('div.MPStats-siteStats', [
            m('span.MPStats-statItem', [
              m('span.MPStats-statIcon.MPStats-siteUpload', '▲'),
              ' ' + siteUpload
            ]),
            m('span.MPStats-statItem', [
              m('span.MPStats-statIcon.MPStats-siteDownload', '▼'),
              ' ' + siteDownload
            ]),
            m('span.MPStats-statItem', [
              m('span.MPStats-statIcon.MPStats-siteRatio', '≈'),
              ' ' + siteRatio
            ]),
            m('span.MPStats-statItem', [
              m('span.MPStats-statIcon', '♺'),
              ' ' + site.seeding
            ]),
            m('span.MPStats-statItem', [
              m('span.MPStats-statIcon.MPStats-siteSeedingSize', '◉'),
              ' ' + seedingSize
            ]),
            site.bonus ? m('span.MPStats-statItem', [
              m('span.MPStats-statIcon.MPStats-siteBonus', '✦'),
              ' ' + (typeof site.bonus === 'number' ? site.bonus.toFixed(1) : site.bonus)
            ]) : null
          ])
        ]);
      });
      
      // 智能格式化数据大小
      const totalUpload = formatSize(summary.total_upload);
      const totalDownload = formatSize(summary.total_download);
      const ratio = (summary.total_download > 0) ? (summary.total_upload / summary.total_download).toFixed(2) : '∞';
      const totalSeedCount = summary.total_seed || 0;
      const totalSeedSize = formatSize(summary.total_seed_size);
      
      // 计算额外的统计数据
      const sitesCount = sites.length;
      const avgSeedPerSite = sitesCount > 0 ? Math.round(totalSeedCount / sitesCount) : 0;
      const avgSeedSizePerSite = sitesCount > 0 ? formatSize(summary.total_seed_size / sitesCount) : '0 B';
      
      // 找出最大做种数和最大做种体积
      let maxSeedCount = 0;
      let maxSeedSize = 0;
      
      sites.forEach(site => {
        if (site.seeding > maxSeedCount) {
          maxSeedCount = site.seeding;
        }
        if ((site.seeding_size || 0) > maxSeedSize) {
          maxSeedSize = site.seeding_size || 0;
        }
      });
      
      const maxSeedSizeFormatted = formatSize(maxSeedSize);
      
      // 十二大站点列表
      const bigSites = [
        '馒头', '皇后', '观众', '彩虹岛', '天空', 
        '朋友', '春天', '憨憨', '猫站', '我堡', 
        '听听歌', '家园'
      ];
      
      // 创建十二大收集状态
      const bigSitesCollection = [];
      const collectedSites = new Set();
      
      // 遍历用户的站点，检查是否包含十二大
      sites.forEach(site => {
        for (const bigSite of bigSites) {
          if (site.name.includes(bigSite)) {
            collectedSites.add(bigSite);
            break;
          }
        }
      });
      
      // 计算收集进度
      const collectionProgress = Math.round((collectedSites.size / bigSites.length) * 100);
      
      // 创建PT人生统计卡片 - 设置低优先级，确保在其他项目之后显示
      items.add('mp-stats', 
        m('.MPStats', [
          m('.MPStats-header', [
            m('.MPStats-headerLeft', [
              m('span.MPStats-title', [
                icon('fas fa-meteor', {className: 'MPStats-icon mr-2'}),
                'PT人生'
              ]),
              isCurrentUser ? m('.MPStats-privacyToggle', [
                m(Switch, {
                  state: isPublic === 1, // 使用数据库中的隐私设置值
                  onchange: (value) => {
                    // 保存到数据库 - 只影响其他用户的查看权限
                    if (app.session.user) {
                      app.request({
                        method: 'PATCH',
                        url: app.forum.attribute('apiUrl') + '/users/' + app.session.user.id(),
                        body: {
                          data: {
                            type: 'users',
                            id: app.session.user.id(),
                            attributes: {
                              mpStatsPublic: value ? 1 : 0
                            }
                          }
                        }
                      }).then(() => {
                        // 保存成功后更新用户属性
                        app.session.user.pushAttributes({
                          mp_stats_public: value ? 1 : 0
                        });
                        
                        // 显示提示
                        app.alerts.show(
                          { type: 'success' },
                          value ? 
                            '统计数据已设为公开，其他用户可以查看' : 
                            '统计数据已设为私密，其他用户将看不到您的详细数据'
                        );
                      }).catch(err => {
                        console.error('保存隐私设置失败:', err);
                        app.alerts.show({ type: 'error' }, '设置保存失败');
                      });
                    }
                    
                    m.redraw();
                  },
                  title: '设置是否向其他用户公开您的统计数据'
                })
              ]) : null,
            ]),
            m('span.MPStats-updated', '更新于: ' + summary.updated_at)
          ]),
          
          // 检查是否应该显示数据 - 自己查看时总是显示，他人查看时根据隐私设置决定
          isCurrentUser || isPublic === 1 ? [
            // 统计卡片布局
            m('.MPStats-summary', [
              m('.MPStats-card', [
                m('.MPStats-cardIcon.MPStats-upload', icon('fas fa-arrow-up')),
                m('.MPStats-cardLabel', '总上传'),
                m('.MPStats-cardValue.MPStats-upload', totalUpload)
              ]),
              m('.MPStats-card', [
                m('.MPStats-cardIcon.MPStats-download', icon('fas fa-arrow-down')),
                m('.MPStats-cardLabel', '总下载'),
                m('.MPStats-cardValue.MPStats-download', totalDownload)
              ]),
              m('.MPStats-card', [
                m('.MPStats-cardIcon.MPStats-ratio', icon('fas fa-balance-scale')),
                m('.MPStats-cardLabel', '分享率'),
                m('.MPStats-cardValue.MPStats-ratio', ratio)
              ]),
              m('.MPStats-card', [
                m('.MPStats-cardIcon.MPStats-seed', icon('fas fa-seedling')),
                m('.MPStats-cardLabel', '做种数'),
                m('.MPStats-cardValue.MPStats-seed', totalSeedCount)
              ]),
              m('.MPStats-card', [
                m('.MPStats-cardIcon.MPStats-seedSize', icon('fas fa-database')),
                m('.MPStats-cardLabel', '做种体积'),
                m('.MPStats-cardValue.MPStats-seedSize', totalSeedSize)
              ])
            ]),
            
            // 十二大收集进度
            m('.MPStats-collectionProgress', [
              m('.MPStats-progressHeader', [
                m('span.MPStats-progressTitle', '收集度'),
                m('span.MPStats-progressValue', [
                  collectedSites.size === bigSites.length ? 
                    m('span.MPStats-complete', [
                      icon('fas fa-crown', {className: 'MPStats-completeIcon'}),
                      ' 全部完成!'
                    ]) : 
                    `${collectionProgress}% (${collectedSites.size}/${bigSites.length})`
                ])
              ]),
              m('.MPStats-progressBar', [
                m('.MPStats-progressFill', {
                  style: {
                    width: `${collectionProgress}%`,
                    background: collectedSites.size === bigSites.length ? 
                      'linear-gradient(90deg, #FF9800, #F44336)' : 
                      `linear-gradient(90deg, #4CAF50 0%, ${collectionProgress < 50 ? '#FFC107' : '#4CAF50'} 100%)`,
                    height: '8px',
                    borderRadius: '4px',
                    transition: 'width 0.5s ease-in-out'
                  }
                })
              ]),
            ]),
            
            // 额外统计信息 - 精简成一行
            m('.MPStats-extraStats', [
              m('.MPStats-statsCompact', [
                m('span.MPStats-statTag.MPStats-sitesCount', [
                  icon('fas fa-server', {className: 'MPStats-statTagIcon'}),
                  ` ${sitesCount} 站点`
                ]),
                m('span.MPStats-statTag.MPStats-avgSeed', [
                  icon('fas fa-seedling', {className: 'MPStats-statTagIcon'}),
                  ` ${avgSeedPerSite} 均种`
                ]),
                m('span.MPStats-statTag.MPStats-avgSize', [
                  icon('fas fa-database', {className: 'MPStats-statTagIcon'}),
                  ` ${avgSeedSizePerSite} 均体积`
                ]),
                m('span.MPStats-statTag.MPStats-maxSeed', [
                  icon('fas fa-trophy', {className: 'MPStats-statTagIcon'}),
                  ` ${maxSeedCount.toLocaleString()} 最大种`
                ]),
                m('span.MPStats-statTag.MPStats-maxSize', [
                  icon('fas fa-award', {className: 'MPStats-statTagIcon'}),
                  ` ${maxSeedSizeFormatted} 最大体积`
                ])
              ])
            ])
          ] : 
          // 显示隐私提示
          m('.MPStats-privateMessage', [
            icon('fas fa-lock', {className: 'MPStats-privateIcon'}),
            m('span.MPStats-privateText', '用户已将统计数据设为私密')
          ]),
          
          // 控制栏
          m('.MPStats-controls', [
            // 隐私控制开关 - 暂时关闭，等待后续重新启用
            /*
            isCurrentUser ? m('.MPStats-visibility', [
              m('span.MPStats-visibilityLabel', '公开站点详情'),
              m(Switch, {
                state: isPublic === 1,
                onchange: (value) => {
                  // 保存到数据库
                  if (app.session.user) {
                    app.request({
                      method: 'PATCH',
                      url: app.forum.attribute('apiUrl') + '/users/' + app.session.user.id(),
                      body: {
                        data: {
                          type: 'users',
                          id: app.session.user.id(),
                          attributes: {
                            mpStatsPublic: value ? 1 : 0
                          }
                        }
                      }
                    }).then(() => {
                      // 保存成功后更新用户属性
                      app.session.user.pushAttributes({
                        mp_stats_public: value ? 1 : 0
                      });
                    }).catch(err => {
                      console.error('保存隐私设置失败:', err);
                    });
                  }
                  
                  m.redraw();
                }
              })
            ]) : null,
            */
            
            // 站点详情部分 - 暂时关闭，等待后续重新启用
            /* 
            (isCurrentUser || (isPublic === 1 && !isCurrentUser)) && sites.length > 0 ? m('.MPStats-sitesDetails', {
              onclick: (e) => {
                const sitesList = e.currentTarget.querySelector('.MPStats-sitesList');
                const toggle = e.currentTarget.querySelector('.MPStats-sitesToggle i');
                
                if (sitesList) {
                  if (sitesList.classList.contains('is-expanded')) {
                    sitesList.classList.remove('is-expanded');
                    toggle.className = 'fas fa-angle-down';
                  } else {
                    sitesList.classList.add('is-expanded');
                    toggle.className = 'fas fa-angle-up';
                  }
                }
              }
            }, [
              m('button.MPStats-sitesToggle', [
                m('i.fas fa-angle-down'),
                `站点详情 (${sites.length})`
              ]),
              m('.MPStats-sitesList', siteItems)
            ]) : !isCurrentUser ? m('.MPStats-noSites', '站点详情已设为私密') : m('.MPStats-noSites', '暂无站点详情')
            */
          ])
        ]),
        -300 // 设置低优先级，确保在其他项目之后显示
      );
      
      console.log('界面组件创建完成');
    } catch (e) {
      console.error('数据解析错误:', e);
      
      // 显示错误信息
      items.add('mp-stats-error', 
        m('.MPStats.MPStats--error', [
          m('.MPStats-header', [
            icon('fas fa-exclamation-triangle', {className: 'MPStats-errorIcon mr-2'}),
            ' 数据解析错误'
          ]),
          m('.MPStats-errorMessage', e.message)
        ])
      );
    }
  });
}); 